export default "/images/my1touch.jpg";